import { createSelector } from '@reduxjs/toolkit';
import type { TypedUseQueryStateResult } from '@reduxjs/toolkit/query/react';

import type { CouponCustomersStatusResponse } from './types';

type GetCouponCustomersStatusFromResultArgs = TypedUseQueryStateResult<
  CouponCustomersStatusResponse,
  unknown,
  any
>;

export const selectHasFreeSupplementsOffer = createSelector(
  (res: GetCouponCustomersStatusFromResultArgs) => res.data,
  (data) =>
    data?.coupons.some(
      (coupon) =>
        coupon.code === 'sub_supplements_free_first_order' &&
        coupon.is_attached_to_customer &&
        coupon.status === 'created',
    ),
);
